module.exports = __webpack_public_path__ + "static/media/12UNCTAD3.19f99d2e.jpg";